export const version = { deployed_version: 'v1.8.3', deployed_commit_sha: '16da844e5f190bc8752aa8ffa9a7b09053a740e9' };
